import curry from "fkit/dist/curry"

export interface UserState {
  blocked: Record<string, unknown>;
  impressions: Record<string, unknown>;
  engagements: Record<string, unknown>;
  visits: number;
}

export const DEFAULT_USER_STATE: UserState = {
  blocked: {},
  impressions: {},
  engagements: {},
  visits: 0,
};

/**
 * Loads the user state.
 *
 * @param storage The storage object.
 * @returns The user state.
 */
export function getUser(storage: Storage | null): UserState {
  if (!storage) {
    return DEFAULT_USER_STATE;
  }

  return JSON.parse(storage.getItem('user') || 'null') || DEFAULT_USER_STATE;
}

/**
 * Stores the given user state.
 *
 * This function is curried for convenience, so that it can be either partially
 * or fully applied.
 *
 * @param storage The storage object.
 * @param user The user state.
 * @returns The user state.
 */
export const setUser = curry((storage: Storage | null, user: UserState): UserState => {
  if (!storage) {
    return DEFAULT_USER_STATE;
  }

  storage.setItem('user', JSON.stringify(user));
  return user;
});
